import { clsx } from 'clsx'
import type { HTMLAttributes, ReactNode } from 'react'

// TailAdmin ComponentCard.tsx: rounded-2xl gray-200 border, px-6 py-5 header with a text-base
// title + text-sm gray-500 description, border-t gray-100 body at p-4 sm:p-6. The actual classes
// live in index.css (.card / .card-header / .card-body) so hand-written markup can match too.
export function Card({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={clsx('card', className)} {...props} />
}

export function ComponentCard({ title, description, action, children, className, bodyClassName }: {
  title?: ReactNode
  description?: ReactNode
  action?: ReactNode
  children: ReactNode
  className?: string
  bodyClassName?: string
}) {
  return (
    <div className={clsx('card', className)}>
      {(title || action) && (
        <div className="card-header flex items-start justify-between gap-4">
          <div>
            {title && <h3 className="card-title">{title}</h3>}
            {description && <p className="card-description">{description}</p>}
          </div>
          {action}
        </div>
      )}
      <div className={clsx(title || action ? 'card-body' : 'p-4 sm:p-6', bodyClassName)}>{children}</div>
    </div>
  )
}
